import * as React from "react";
import { SkeletonWrapper } from "src/components/Skeleton/SkeletonWrapper.component";
import { withStyles } from "src/decorators";
import styled from "styled-components";

const SkeletonTextEl = styled.div`
  background-color: rgba(10, 20, 30, 0.05);
  border-radius: 2px;

  > * {
    opacity: 0;
  }
`;

export const SkeletonText = withStyles(({ children, ...others }: any) => (
  <SkeletonWrapper {...others}>
    <SkeletonTextEl>{children}</SkeletonTextEl>
  </SkeletonWrapper>
));
